import type { APITeoMarker, WordListData } from '@/teoCore/TeoApi';
import { TeoEventTarget } from '@/teoCore/utility/TeoEventTarget';

import type { TeoText } from '../TeoText';

export type WhiteListHandlerEvents = {
  isAvailableChanged: (isAvailable: boolean) => void;
  hasEntriesChanged: (hasEntries: boolean) => void;
  isActiveChanged: (isActive: boolean) => void;
};

export class WhiteListHandler {
  public events = new TeoEventTarget<WhiteListHandlerEvents>();
  private lists: WordListData[] = [];
  private _isAvailable = false;
  private _hasEntries = false;
  private _isActive = true;
  public markers: APITeoMarker[] = [];
  constructor(private text: TeoText) {}

  get isAvailable(): boolean {
    return this._isAvailable;
  }

  get hasEntries(): boolean {
    return this._hasEntries;
  }

  get isActive(): boolean {
    return this._isActive;
  }

  private set isAvailable(value: boolean) {
    if (this._isAvailable === value) return;
    this._isAvailable = value;
    this.events.triggerEvent('isAvailableChanged', value);
  }

  private set hasEntries(value: boolean) {
    if (this._hasEntries === value) return;
    this._hasEntries = value;
    this.events.triggerEvent('hasEntriesChanged', value);
  }

  set isActive(value: boolean) {
    if (this._isActive === value) return;
    this._isActive = value;
    this.events.triggerEvent('isActiveChanged', value);
    this.text.analysisConfigChanged();
  }

  markEntries(): void {
    // this.wordLists.mark(this.lists, false);
    this.text.markers.setMarkers(['whitelisted']);
  }

  unmarkEntries(): void {
    // this.wordLists.mark([]);
    this.text.markers.removeMarkers(['whitelisted']);
  }
}
